import {Injectable} from "@angular/core";
import {HttpHeaders} from "@angular/common/http";

declare const gapi: any;

@Injectable()
export class AuthApiService {

    private auth2: any;

    /**
     * resolve from Promises that have been referred resolution until the google API has finished initialising
     */
    private pendingLoginChecks: any[] = [];

    private portalToken: string;

    constructor() {
        gapi.load("auth2", () => {
            this.auth2 = gapi.auth2.init({
                client_id: "676822692728-gsaj2eid1q69sp7ngos51g7pus974q1t.apps.googleusercontent.com",
                cookiepolicy: "single_host_origin",
                scope: "profile email"
            });

            if (this.pendingLoginChecks) {
                setTimeout(() => {
                    this.pendingLoginChecks.forEach((loginResolve) => {
                        loginResolve(this.loginStatus());
                    });
                }, 3000); // there is a delay before auth2 is fully initialised

            }
        });
    }

    public get initialised(): boolean {
        return this.auth2 !== undefined;
    }

    public signIn(): Promise<any> {
        return this.auth2.signIn();
    }

    public logout(): Promise<any> {
        return this.auth2.signOut();
    }

    public getName(): string {
        if (this.auth2.currentUser.get().getBasicProfile()) {
            return this.auth2.currentUser.get().getBasicProfile().getName();
        }

        return null;
    }

    public getEmail(): string {
        if (this.auth2.currentUser.get().getBasicProfile()) {
            return this.auth2.currentUser.get().getBasicProfile().getEmail();
        }

        return null;
    }

    public getDomain(): string {
        return this.auth2.currentUser.get().getHostedDomain();
    }


    public isLoggedIn(): Promise<boolean> {
        if (this.initialised) {
            return new Promise<boolean>((resolve) => {
                resolve(this.loginStatus());
            });
        } else {
            return new Promise<boolean>((resolve => {
                this.pendingLoginChecks.push(resolve);
            }));
        }
    }

    public getToken(): string {
        return this.auth2.currentUser.get().getAuthResponse().id_token;
    }

    public signInUsingSignUpToken(token: string): void {
        this.portalToken = token;
    }

    public getHttpHeaderOptions(): HttpHeaders {
        if (this.portalToken) {
            return new HttpHeaders().set("Content-Type", "application/json").set("portalToken",this.portalToken);
        } else {
            return new HttpHeaders().set("Content-Type", "application/json").set("token",this.getToken());
        }
    }

    public getHttpHeaderOptionsForFile(): HttpHeaders {
        if (this.portalToken) {
            return new HttpHeaders().set("portalToken",this.portalToken);
        } else {
            return new HttpHeaders().set("token",this.getToken());
        }
    }

    /**
     * Indicates if the user has logged in. The status is false if the API has not initialised
     */
    public loginStatus(): boolean {
        return this.auth2 && this.getToken() && this.getDomain() === "chewzie.me";
    }
}
